export const environment = {
  production: false,
  apiUrl: "https://api.agbe-asso.fr",
};
